import { jsx as e } from "react/jsx-runtime";
import { useStripe as i, PaymentElement as r } from "../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
function o() {
  return i() ? /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(
    r,
    {
      options: {
        fields: {
          billingDetails: {
            name: "never",
            email: "never"
          }
        }
      }
    }
  ) }) : null;
}
export {
  o as StripeKlarnaDetails
};
